import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    hasAudioEnabled: false,
    hasShownAudioModal: false,
    randomGeneratedJackpotInterval: (Math.floor(Math.random() * (16 - 10)) + 10)
  },
  mutations: {
    enableAudio (state) {
      state.hasAudioEnabled = true
    },
    disableAudio (state) {
      state.hasAudioEnabled = false
    },
    setHasShownAudioModal (state) {
      state.hasShownAudioModal = true
    }
  },
  actions: {
    setAudio (context) {
      if (!this.state.hasAudioEnabled) {
        context.commit('enableAudio')
      } else {
        context.commit('disableAudio')
      }
    },
    enableAudio (context) {
      context.commit('setHasShownAudioModal')
      context.commit('enableAudio')
    },
    disableAudio (context) {
      context.commit('setHasShownAudioModal')
    }
  }
})
